module.exports = __webpack_public_path__ + "static/media/icon_calendar_2.0aa26805.svg";